export const unitTitleMap = {
  'k5 elem gk u1': 'Growth Mindset & Goal-Setting',
  'k5 elem gk u2': 'Emotion Management',
  'k5 elem gk u3': 'Empathy & Kindness',
  'k5 elem gk u4': 'Problem-Solving',

  'k5 elem g1 u1': 'Growth Mindset & Goal-Setting',
  'k5 elem g1 u1d': 'Growth Mindset & Goal-Setting',
  'k5 elem g1 u2': 'Emotion Management',
  'k5 elem g1 u3': 'Empathy & Kindness',
  'k5 elem g1 u4': 'Problem-Solving',

  'k5 elem g2 u1': 'Growth Mindset & Goal-Setting',
  'k5 elem g2 u2': 'Emotion Management',
  'k5 elem g2 u3': 'Empathy & Kindness',
  'k5 elem g2 u4': 'Problem-Solving',

  'k5 elem g3 u1': 'Growth Mindset & Goal-Setting',
  'k5 elem g3 u2': 'Emotion Management',
  'k5 elem g3 u3': 'Empathy & Kindness',
  'k5 elem g3 u3 l1': 'Empathy & Kindness',
  'k5 elem g3 u4': 'Problem-Solving',

  'k5 elem g4 u1': 'Growth Mindset & Goal-Setting',
  'k5 elem g4 u2': 'Emotion Management',
  'k5 elem g4 u3': 'Empathy & Kindness',
  'k5 elem g4 u4': 'Problem-Solving',

  'k5 elem g5 u1': 'Growth Mindset & Goal-Setting',
  'k5 elem g5 u2': 'Emotion Management',
  'k5 elem g5 u3': 'Empathy & Kindness',
  'k5 elem g5 u4': 'Problem-Solving',

  'ms g6 u1': 'Mindset & Goals',
  'ms g6 u2': 'Developing a Positive Sense of Self',
  'ms g6 u3': 'Thoughts, Emotions, and Decisions',
  'ms g6 u4': 'Managing Relationships & Social Conflict',
  'ms g6 rbh, opt-in': 'Recognizing Bullying & Harassment',
  'ms g7 u1': 'Mindset & Goals',
  'ms g7 u2': 'Developing a Positive Sense of Self',
  'ms g7 u3': 'Thoughts, Emotions, and Decisions',
  'ms g7 u4': 'Managing Relationships & Social Conflict',
  'ms g7 rbh, opt-in': 'Recognizing Bullying & Harassment',
  'ms g8 u1': 'Mindset & Goals',
  'ms g8 u2': 'Developing a Positive Sense of Self',
  'ms g8 u3': 'Thoughts, Emotions, and Decisions',
  'ms g8 u4': 'Managing Relationships & Social Conflict',
  'ms g8 rbh, opt-in': 'Recognizing Bullying & Harassment',

  // Tier 2 K-2 Unit Mappings
  'k8 tier2 gk-2 u1': 'Emotions, Thoughts & Feelings',
  'k8 tier2 gk-2 u2': 'Relationship & Prosocial Skills',
  'k8 tier2 gk-2 u3': 'Executive Functioning',

  // Tier 2 3-5 Unit Mappings
  'k8 tier2 g3-5 u1': 'Emotions, Thoughts & Feelings',
  'k8 tier2 g3-5 u2': 'Relationship & Prosocial Skills',
  'k8 tier2 g3-5 u3': 'Executive Functioning',

  // Tier 2 6-8 Unit Mappings
  'k8 tier2 g6-8 u1': 'Emotions, Thoughts & Feelings',
  'k8 tier2 g6-8 u2': 'Relationship & Prosocial Skills',
  'k8 tier2 g6-8 u3': 'Executive Functioning',
}

export const lessonTitleMap = {
  // Digital Well-Being (Specialized Units report tab), grades K-12
  'gk dwb l01': 'Launching into Space',
  'gk dwb l02': 'Two Sides of Your Moon',
  'gk dwb l03': 'Sending Waves into Space',
  'gk dwb l04': 'Space Storm',
  'gk dwb l05': 'The Junior Explorer’s Code',
  'g1 dwb l01': 'Two Sides of the Station',
  'g1 dwb l02': 'Kind Signals Everywhere',
  'g1 dwb l03': 'Your Personal Locker',
  'g1 dwb l04': 'Checking Your Battery',
  'g1 dwb l05': 'Your Room on the Station',
  'g2 dwb l01': 'Your Arrival',
  'g2 dwb l02': 'Your Base Sign',
  'g2 dwb l03': 'Your Island Safe',
  'g2 dwb l04': 'Island Mystery',
  'g2 dwb l05': 'Market Day',
  'g3 dwb l01': 'Welcome to the Island',
  'g3 dwb l02': 'Ad Alerts',
  'g3 dwb l03': 'Community Helpers',
  'g3 dwb l04': 'Spicy Rumor Review',
  'g3 dwb l05': 'Celebration Day!',
  'g4 dwb l01': 'The Power of Words Online',
  'g4 dwb l02': 'Being Kind Before Reacting',
  'g4 dwb l03': 'The Trail We Leave',
  'g4 dwb l04': 'Making Mistakes, Making Amends',
  'g4 dwb l05': 'My Story, My Choice',
  'g5 dwb l01': 'The Invisible Editor',
  'g5 dwb l02': 'Avoiding Online Traps',
  'g5 dwb l03': 'Personas and Influencers',
  'g5 dwb l04': 'Accessibility and Content Creation',
  'g5 dwb l05': 'Digital Influencer Challenge',
  'g6 dwb l01': 'The Right Balance',
  'g6 dwb l02': 'Digital Life',
  'g6 dwb l03': 'What’s In a Balanced Plan?',
  'g6 dwb l04': 'A Plan That Works',
  'g6 dwb l05': 'Balancing Act',
  'g7 dwb l01': 'Information Overload',
  'g7 dwb l02': 'Evaluating Information',
  'g7 dwb l03': 'Echo Chambers',
  'g7 dwb l04': 'Media’s Influence',
  'g7 dwb l05': 'Responsible Media Campaign',
  'g8 dwb l01': 'Digital Communities',
  'g8 dwb l02': 'Online Harm',
  'g8 dwb l03': 'Online Influences',
  'g8 dwb l04': 'Safe Responses',
  'g8 dwb l05': 'Digital Upstander Actions',
  'g9 dwb l01': 'AI Everywhere',
  'g9 dwb l02': 'Parasocial Relationships',
  'g9 dwb l03': 'Recognizing AI Influence',
  'g9 dwb l04': 'Informed AI Use',
  'g9 dwb l05': 'AI Now',
  'g10 dwb l01': 'Online Community Signals',
  'g10 dwb l02': 'Dangerous Online Situations',
  'g10 dwb l03': 'Safe Spaces',
  'g10 dwb l04': 'Strengthen Tools',
  'g10 dwb l05': 'Community Commitments',
  'g11 dwb l01': 'Community Challenges',
  'g11 dwb l02': 'Digital Solutions',
  'g11 dwb l03': 'Solution Prototypes',
  'g11 dwb l04': 'Prototype Analysis',
  'g11 dwb l05': 'Action Plan',
  'g12 dwb l01': 'School Technology Policies',
  'g12 dwb l02': 'Digital Regulations',
  'g12 dwb l03': 'AI Trade-Offs',
  'g12 dwb l04': 'Leading Through Uncertainty',
  'g12 dwb l05': 'Ready to Lead',

  'k5 elem gk u1 l01': 'We Watch. We Listen. We Think.',
  'k5 elem gk u1 l02': 'Why We Pay Attention',
  'k5 elem gk u1 l03': 'Mistakes Are Okay!',
  'k5 elem gk u1 l04': 'Practice Makes Better',
  'k5 elem gk u1 l05': 'Performance Task: Let’s Practice and Learn!',
  'k5 elem gk u2 l06': 'Sometimes We Feel Happy',
  'k5 elem gk u2 l07': 'Sometimes We Feel Sad',
  'k5 elem gk u2 l08': 'Sometimes We Feel Mad',
  'k5 elem gk u2 l09': 'We Can Feel Calm',
  'k5 elem gk u2 l10': 'Performance Task: What Are They Feeling?',
  'k5 elem gk u3 l11': 'We Can Be Kind',
  'k5 elem gk u3 l12': 'Why Kindness?',
  'k5 elem gk u3 l13': 'Showing Kindness',
  'k5 elem gk u3 l14': 'Kindness at School',
  'k5 elem gk u3 l15': 'Performance Task: Demonstrating Kindness',
  'k5 elem gk u4 l16': 'We Can Say the Problem',
  'k5 elem gk u4 l17': 'Ready to Solve Problems',
  'k5 elem gk u4 l18': 'Apologizing Can Help',
  'k5 elem gk u4 l19': 'Taking Turns and Sharing',
  'k5 elem gk u4 l20': 'Performance Task: We Can Solve Problems',

  'k5 elem g1 u1 l01': 'Time to Pay Attention',
  'k5 elem g1 u1 l02': 'Everyone Gets Distracted',
  'k5 elem g1 u1 l03': 'You Did It!',
  'k5 elem g1 u1 l04': 'Helpful Thoughts',
  'k5 elem g1 u1 l05': 'Performance Task: We Can Do It!',
  'k5 elem g1 u2 l06': 'Noticing Feelings',
  'k5 elem g1 u2 l07': 'Sometimes We Feel Worried',
  'k5 elem g1 u2 l08': 'Feeling Calm',
  'k5 elem g1 u2 l09': 'Feeling Frustrated',
  'k5 elem g1 u2 l10': 'Performance Task: Noticing Clues',
  'k5 elem g1 u3 l11': 'The Power of Kind Acts',
  'k5 elem g1 u3 l12': 'Ways to Be Kind',
  'k5 elem g1 u3 l13': 'Offering Kind Acts',
  'k5 elem g1 u3 l14': 'Practicing Kind Acts',
  'k5 elem g1 u3 l15': 'Performance Task: Demonstrating Kind Acts',
  'k5 elem g1 u4 l16': 'How to Say the Problem',
  'k5 elem g1 u4 l17': 'Was It an Accident?',
  'k5 elem g1 u4 l18': 'Ask for What You Need',
  'k5 elem g1 u4 l19': 'We Can Make It Better',
  'k5 elem g1 u4 l20': 'Performance Task: Solving Problems',

  'k5 elem g2 u1 l01': 'How to Get Good at Something',
  'k5 elem g2 u1 l02': 'What Mistakes Tell Us',
  'k5 elem g2 u1 l03': 'Helpful and Unhelpful Thoughts',
  'k5 elem g2 u1 l04': 'We Can Change Our Thoughts',
  'k5 elem g2 u1 l05': 'Performance Task: Learn and Get Better',
  'k5 elem g2 u2 l06': 'Feeling Proud',
  'k5 elem g2 u2 l07': 'Feeling Disappointed',
  'k5 elem g2 u2 l08': 'Help Yourself Feel Better',
  'k5 elem g2 u2 l09': 'Different Feelings',
  'k5 elem g2 u2 l10': 'Performance Task: How Do You Feel?',
  'k5 elem g2 u3 l11': "What's Empathy?",
  'k5 elem g2 u3 l12': 'Empathy in Action',
  'k5 elem g2 u3 l13': 'Having Empathy',
  'k5 elem g2 u3 l14': 'Empathy at School',
  'k5 elem g2 u3 l15': 'Performance Task: Empathy and Kindness',
  'k5 elem g2 u4 l16': 'The Way to Say a Problem',
  'k5 elem g2 u4 l17': 'Thinking of Solutions',
  'k5 elem g2 u4 l18': 'Which Solution?',
  'k5 elem g2 u4 l19': 'What Would I Want?',
  'k5 elem g2 u4 l20': 'Performance Task: Be a Problem-Solver',

  'k5 elem g3 u1 l01': 'Changing Your Brain',
  'k5 elem g3 u1 l02': 'Getting Better with Practice',
  'k5 elem g3 u1 l03': 'More Than Practice',
  'k5 elem g3 u1 l04': 'Planning for Practice',
  'k5 elem g3 u1 l05': 'Performance Task: Make a Practice Plan',
  'k5 elem g3 u2 l06': 'Why Emotions?',
  'k5 elem g3 u2 l07': 'How Angry?',
  'k5 elem g3 u2 l08': 'Take a Break',
  'k5 elem g3 u2 l09': 'How Happy?',
  'k5 elem g3 u2 l10': 'Performance Task: Strength of Feelings',
  'k5 elem g3 u3 l11': 'Kindness and Friendship',
  'k5 elem g3 u3 l12': 'Building a Friendship',
  'k5 elem g3 u3 l13': 'My Kind of Kindness',
  'k5 elem g3 u3 l14': 'Asking Questions',
  'k5 elem g3 u3 l15': 'Performance Task: Do Something Kind',
  'k5 elem g3 u4 l16': 'STEP by Step',
  'k5 elem g3 u4 l17': 'S: Say the Problem',
  'k5 elem g3 u4 l18': 'T: Think and E: Explore',
  'k5 elem g3 u4 l19': 'P: Pick a Solution',
  'k5 elem g3 u4 l20': 'Performance Task: Solving a Problem',

  'k5 elem g4 u1 l01': 'Setting a Good Goal',
  'k5 elem g4 u1 l02': 'Making a Plan',
  'k5 elem g4 u1 l03': 'Checking Our Progress',
  'k5 elem g4 u1 l04': 'Reflecting On Our Journey',
  'k5 elem g4 u1 l05 **presNEW25': 'Performance Task: Gallery Walk Celebration',
  'k5 elem g4 u2 l06': 'The Balanced Brain',
  'k5 elem g4 u2 l07': 'What Is Rethinking?',
  'k5 elem g4 u2 l08': 'How to Rethink',
  'k5 elem g4 u2 l09': 'Take Another Look',
  'k5 elem g4 u2 l10': 'Performance Task: Rethink It!',
  'k5 elem g4 u3 l11': 'The Same, But Different',
  'k5 elem g4 u3 l12': 'Ask, Listen, Learn',
  'k5 elem g4 u3 l13': 'Seeing It Differently',
  'k5 elem g4 u3 l14': 'Changing Your Mind',
  'k5 elem g4 u3 l15': 'Performance Task: A New Point of View',
  'k5 elem g4 u4 l16': 'A Good Problem-Solver',
  'k5 elem g4 u4 l17': 'Saying It Respectfully',
  'k5 elem g4 u4 l18': 'Exploring Outcomes',
  'k5 elem g4 u4 l19': 'A Good Solution',
  'k5 elem g4 u4 l20': 'Performance Task: STEP into Problem-Solving',

  'k5 elem g5 u1 l01 **presNEW25': `Let's Dream Big!`,
  'k5 elem g5 u1 l02 **presNEW25': 'The Power of a Good Goal',
  'k5 elem g5 u1 l03 **presNEW25': 'Habits for Success!',
  'k5 elem g5 u1 l04 **presNEW25': 'Overcoming Obstacles',
  'k5 elem g5 u1 l05 **presNEW25': 'Performance Task: Continuous Improvement',
  'k5 elem g5 u2 l06': 'Strong Emotions',
  'k5 elem g5 u2 l07': 'What Is Stress?',
  'k5 elem g5 u2 l08': 'Planning for Change',
  'k5 elem g5 u2 l09': 'What Can I Change?',
  'k5 elem g5 u2 l10': 'Performance Task: Making a Change',
  'k5 elem g5 u3 l11': 'Empathy in the Community',
  'k5 elem g5 u3 l12': 'What’s the Problem?',
  'k5 elem g5 u3 l13': 'A Different Point of View',
  'k5 elem g5 u3 l14': 'Community Solutions',
  'k5 elem g5 u3 l15': 'Performance Task: Your Solution',
  'k5 elem g5 u4 l16': 'Beginning to STEP',
  'k5 elem g5 u4 l17': 'When? Where? Who?',
  'k5 elem g5 u4 l18': 'Solutions Web',
  'k5 elem g5 u4 l19': 'Let’s Reflect',
  'k5 elem g5 u4 l20': 'Performance Task: Putting It All Together',

  'ms g6 u1 l01a-b *choice': 'Starting Middle School/Helping New Students',
  'ms g6 u1 l01a': 'Starting Middle School',
  'ms g6 u1 l01b': 'Helping New Students',
  'ms g6 u1 l01 - NEW 2025': 'A Soundtrack for Success',
  'ms g6 u1 l02': 'How to Grow Your Brain',
  'ms g6 u1 l03': 'Trying New Strategies',
  'ms g6 u1 l04': 'Making Goals Specific',
  'ms g6 u1 l05': 'Breaking Down Your Goals',
  'ms g6 u1 l06': 'Monitoring Your Progress',
  'ms g6 u1 l07': 'Performance Task: Bringing It All Together',
  'ms g6 u2 l08': 'What Are Guiding Principles?',
  'ms g6 u2 l09': 'Your Guiding Principles',
  'ms g6 u2 l10': 'Making Decisions',
  'ms g6 u2 l11': 'Multiple Guiding Principles',
  'ms g6 u2 l12': 'Thinking Short-Term and Long-Term',
  'ms g6 u2 l13': 'Performance Task: Using Your Guiding Principles',
  'ms g6 u3 l14': 'What Emotions Tell You',
  'ms g6 u3 l15': 'Emotions and Your Brain',
  'ms g6 u3 l16': 'How Emotions Affect Your Decisions',
  'ms g6 u3 l17': 'Managing Your Emotions',
  'ms g6 u3 l18': 'What Works Best for You?',
  'ms g6 u3 l19': 'Performance Task: Raising Awareness About Managing Emotions',
  'ms g6 u4 l20': `You're Changing`,
  'ms g6 u4 l21': 'Why Conflicts Escalate',
  'ms g6 u4 l22': 'Considering Multiple Perspectives',
  'ms g6 u4 l23': 'Respectful Communication',
  'ms g6 u4 l24': 'Resolving Challenging Conflicts',
  'ms g6 u4 l25': 'Making Amends',
  'ms g6 u4 l26': 'Performance Task: Conflict Solvers',
  'ms g6 u4 l27': 'High School Challenges',
  'ms g6 rbh l01': 'Common Types of Bullying',
  'ms g6 rbh l02': 'Recognizing Bullying',
  'ms g6 rbh l03': 'Responding to Online Bullying',
  'ms g6 rbh l04': 'How to Be an Upstander',
  'ms g6 rbh l05': 'Standing Up and Staying Safe',
  'ms g6 rbh l06': 'Performance Task: Raising Awareness About Bullying',
  'ms g7 u1 l01a-b *choice': 'Starting Middle School/Helping New Students',
  'ms g7 u1 l01a': 'Starting Middle School',
  'ms g7 u1 l01b': 'Helping New Students',
  'ms g7 u1 l01 - NEW 2025': 'Designing Your Future',
  'ms g7 u1 l02 **presNEW25': 'Creating New Pathways in Your Brain',
  'ms g7 u1 l03 **presNEW25': 'Learning from Obstacles',
  'ms g7 u1 l04 **presNEW25': 'Identifying Obstacles',
  'ms g7 u1 l05 **presNEW25': 'Overcoming Obstacles',
  'ms g7 u1 l06 **presNEW25': 'Creating an If-Then Plan',
  'ms g7 u1 l07 **presNEW25':
    'Performance Task: Reflecting on Your If-Then Plan',
  'ms g7 u1 l02': 'Creating New Pathways in Your Brain',
  'ms g7 u1 l03': 'Learning from Mistakes and Failure',
  'ms g7 u1 l04': 'Identifying Roadblocks',
  'ms g7 u1 l05': 'Overcoming Roadblocks 1',
  'ms g7 u1 l06': 'Overcoming Roadblocks 2',
  'ms g7 u1 l07': 'Performance Task: Advice on Roadblocks',
  'ms g7 u2 l08': 'What is Self-Concept',
  'ms g7 u2 l09': 'Your Self-Concept',
  'ms g7 u2 l10': 'Influences on Self-Concept',
  'ms g7 u2 l11': 'Changes in Self-Concept',
  'ms g7 u2 l12': 'Your Future Self-Concept',
  'ms g7 u2 l13': 'Performance Task: Who Will You Become?',
  'ms g7 u3 l14': 'Emotions Matter',
  'ms g7 u3 l15': 'Feel, Think, Do',
  'ms g7 u3 l16': 'Unhelpful Thoughts',
  'ms g7 u3 l17': 'Reframe the Situation',
  'ms g7 u3 l18': 'Practicing Positive Self-Talk',
  'ms g7 u3 l19': 'Performance Task: Making Better Decisions',
  'ms g7 u4 l20': 'What Makes a Conflict Escalate?',
  'ms g7 u4 l21': 'Keeping Your Cool in a Conflict',
  'ms g7 u4 l22': 'Conflicts and Perspectives',
  'ms g7 u4 l23': 'Resolving Conflict Part 1',
  'ms g7 u4 l24': 'Resolving Conflict Part 2',
  'ms g7 u4 l25': 'Taking Responsibility for Your Actions',
  'ms g7 u4 l26': 'Performance Task: Tips for Resolving Conflicts',
  'ms g7 rbh l01': 'What is Harassment?',
  'ms g7 rbh l02': 'What is Sexual Harassment?',
  'ms g7 rbh l03': 'The Effects of Sexual Harassment',
  'ms g7 rbh l04': 'Harassment Based on Stereotypes',
  'ms g7 rbh l05': 'Our Rights and Responsibilities',
  'ms g7 rbh l06': 'Performance Task: Preventing Harassment',
  'ms g8 u1 l01 **presNEW25': 'Adjust and Achieve',
  'ms g8 u1 l02 **presNEW25': 'Motivation',
  'ms g8 u1 l03 **presNEW25': 'Motivation Factors 1',
  'ms g8 u1 l04 **presNEW25': 'Motivation Factors 2',
  'ms g8 u1 l05 **presNEW25': 'Strategies for Motivation',
  'ms g8 u1 l06 **presNEW25': 'Increasing Your Motivation',
  'ms g8 u1 l07 **presNEW25': 'Performance Task: Your Motivation Plan',
  'ms g8 u1 l01': 'Welcome!',
  'ms g8 u1 l02': 'Who Am I? My Identity',
  'ms g8 u1 l03': 'My Interests and Strengths',
  'ms g8 u1 l04': 'Harnessing My Strengths',
  'ms g8 u1 l05': 'Pursuing My Interests',
  'ms g8 u1 l06': 'My Future Self',
  'ms g8 u1 l07': 'Performance Task: My Path Forward',
  'ms g8 u2 l08': 'Agency',
  'ms g8 u2 l09': 'Sources of Confidence',
  'ms g8 u2 l10': 'How to Build Confidence 1',
  'ms g8 u2 l11': 'How to Build Confidence 2',
  'ms g8 u2 l12': 'Agency and Confidence',
  'ms g8 u2 l13': 'Performance Task: Your Confidence-Building Plan',
  'ms g8 u3 l14': 'Understanding Stress and Anxiety',
  'ms g8 u3 l15': 'Where Does Stress Come From?',
  'ms g8 u3 l16': 'Can Stress Help You Grow?',
  'ms g8 u3 l17': 'Strategies for Managing Stress',
  'ms g8 u3 l18': 'Changing Strategies and Getting Help',
  'ms g8 u3 l19': 'Performance Task: My Stress-Management Plan',
  'ms g8 u4 l20': 'My Values',
  'ms g8 u4 l21': 'Values and Relationships',
  'ms g8 u4 l22': `Respecting Others' Perspectives`,
  'ms g8 u4 l23': 'Finding the Best Solution',
  'ms g8 u4 l24': 'Making Things Right',
  'ms g8 u4 l25': 'Unhealthy Relationships',
  'ms g8 u4 l26': 'Performance Task: Guide to Healthy Relationships',
  'ms g8 u4 l27': 'High School Challenges',
  'ms g8 rbh l01': 'Understanding Bullying',
  'ms g8 rbh l02': 'Social Factors that Contribute to Bullying',
  'ms g8 rbh l03': 'Environmental Factors that Contribute to Bullying',
  'ms g8 rbh l04': 'Speak Up and Start a Movement',
  'ms g8 rbh l05': 'Be Inclusive and Ask for a Change',
  'ms g8 rbh l06': 'Performance Task: Stand Up for Change!',

  // Tier 2 K-2 Lesson Mappings
  'k8 tier2 gk-2 u1 l01': 'We All Feel Emotions',
  'k8 tier2 gk-2 u1 l02': 'Hello, Body',
  'k8 tier2 gk-2 u1 l03': 'Ways to Feel Calm',
  'k8 tier2 gk-2 u1 l04': 'Changing Thoughts',
  'k8 tier2 gk-2 u1 l05': 'Flip That Thought',
  'k8 tier2 gk-2 u1 l06': 'Practicing Calm',

  'k8 tier2 gk-2 u2 l01': 'Kind Words and Actions',
  'k8 tier2 gk-2 u2 l02': 'More Kind Words and Actions',
  'k8 tier2 gk-2 u2 l03': 'Understanding How Others Feel',
  'k8 tier2 gk-2 u2 l04': 'More Ways to Understand Others',
  'k8 tier2 gk-2 u2 l05': 'Solving Small Problems',
  'k8 tier2 gk-2 u2 l06': 'Solving Problems in New Ways',

  'k8 tier2 gk-2 u3 l01': 'Paying Attention and Following Directions',
  'k8 tier2 gk-2 u3 l02': "Wait! Let's Think First",
  'k8 tier2 gk-2 u3 l03': 'Remembering What to Do, Part 1',
  'k8 tier2 gk-2 u3 l04': 'Remembering What to Do, Part 2',
  'k8 tier2 gk-2 u3 l05': 'Creative Thinking',
  'k8 tier2 gk-2 u3 l06': 'Mistakes Are Okay',

  // Tier 2 3-5 Lesson Mappings
  'k8 tier2 g3-5 u1 l01': 'What Emotions Tell Us',
  'k8 tier2 g3-5 u1 l02':
    'Feelings in the Thoughts, Feelings, Actions Triangle',
  'k8 tier2 g3-5 u1 l03': 'Actions in the Thoughts, Feelings, Actions Triangle',
  'k8 tier2 g3-5 u1 l04': 'Managing Our Feelings',
  'k8 tier2 g3-5 u1 l05': 'Counting to Calm',
  'k8 tier2 g3-5 u1 l06': 'Bouncing Back',

  'k8 tier2 g3-5 u2 l01': 'Kind Words and Actions',
  'k8 tier2 g3-5 u2 l02': 'More Kind Words and Actions',
  'k8 tier2 g3-5 u2 l03': 'Looking At It a Different Way',
  'k8 tier2 g3-5 u2 l04': 'Thinking Differently About Others',
  'k8 tier2 g3-5 u2 l05': 'Prolem-Solving Strategies',
  'k8 tier2 g3-5 u2 l06': 'More Problem-Solving Strategies',

  'k8 tier2 g3-5 u3 l01': 'Staying on Task Despite Distractions',
  'k8 tier2 g3-5 u3 l02': 'Working Memory',
  'k8 tier2 g3-5 u3 l03': 'Creative Thinking',
  'k8 tier2 g3-5 u3 l04': 'Switching Tasks',
  'k8 tier2 g3-5 u3 l05': 'Thinking Differently When Facing Obstacles',
  'k8 tier2 g3-5 u3 l06': 'Still Thinking Differently When Facing Obstacles',

  // Tier 2 6-8 Lesson Mappings
  'k8 tier2 g6-8 u1 l01': 'Two Ways to Manage Your Emotions',
  'k8 tier2 g6-8 u1 l02': 'Stress Release',
  'k8 tier2 g6-8 u1 l03': 'Manage Your Triangle',
  'k8 tier2 g6-8 u1 l04': 'Realistic Thinking',
  'k8 tier2 g6-8 u1 l05': 'Emotional Carryover',
  'k8 tier2 g6-8 u1 l06': 'Bounce Back Toolkit',

  'k8 tier2 g6-8 u2 l01': 'Active Listening',
  'k8 tier2 g6-8 u2 l02': 'Good Relationships',
  'k8 tier2 g6-8 u2 l03': 'Seeing What Others See',
  'k8 tier2 g6-8 u2 l04': 'Digital World Perspective-Taking',
  'k8 tier2 g6-8 u2 l05': 'Staying Calm in Conflicts',
  'k8 tier2 g6-8 u2 l06': 'Investigating Conflicts',

  'k8 tier2 g6-8 u3 l01': 'Creative Designs',
  'k8 tier2 g6-8 u3 l02': 'DREAM Goals',
  'k8 tier2 g6-8 u3 l03': 'Planning DREAM Goals',
  'k8 tier2 g6-8 u3 l04': 'Adjust the Plan, Keep the Goal',
  'k8 tier2 g6-8 u3 l05': 'If—Then Plans',
  'k8 tier2 g6-8 u3 l06': 'What—Now Plans',
}
